import type { FaireProductEntity } from "../../entity_types/product";

export const p_3c9objikox: FaireProductEntity = {
  token: "p_3c9objikox",
  type: "product",
  name: "Mustard and Himalayan Pillow 2 sizes",
  brandToken: "b_b067eaumjh",
  brandName: "Happy French Gang",
  imageUrl:
    "https://cdn.faire.com/fastly/53e331d06eb0e3ee5a484a1028b250c5574fcecdc08deba5882b4165efd90501.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b85bab511bf71cdf1c21c31ed4ee751980a870e81c3060b988bfe69d1fbe92a1.jpeg",
    "https://cdn.faire.com/fastly/9dbeb9a8a84e7c3519c3ff5fda7090be3d5c2d5eedf8ffddaf54fad91c487248.jpeg",
  ],
  priceDollars: 70,
  description:
    'Color: mustard/Himalayan.\nSize: 28” x 28” or 18" x 18"\nNatural dyes.\n100% organic cotton, hand-spun and handwoven.\nInsert with feather (95%) and down (5%) included. ',
  tags: [],
  msrpDollars: 140,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:11:00.272Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
